import React, { useState, useContext } from "react";
import { GetBold, OrderDetails } from "../../styles/myOrders-style";
import Image from "next/image";
import { OrderWithDelivery } from "../../models/order";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { toggleChatSelector } from "../../store/selectors/common.selectors";
import { toggleChatAction } from "../../store/slices/common.slice";
import { ChatContext } from "../../contexts/ChatContext";
import useProduct from "../../hooks/product/useProduct";
import striptags from "striptags";
import { OverlayTrigger, Popover, Table } from "react-bootstrap";
import router from "next/router";
import { bankersRound, shorten, twoDecimals, twoDecimalsFixed } from "../../util/util";
import { FaInfo } from "react-icons/fa";
import ReactHtmlParser from 'react-html-parser';
import useOrders from "../../hooks/order/useOrders";
import { tagRemoveFromCart } from "../../lib/events";
import Link from "next/link";
import animeLoading from "../../public/lottie/14117-crypto-loader.json";
import Lottie from "react-lottie";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { OrderContext } from "../../contexts/OrdersContext";


interface CartInfoProps {
  order: OrderWithDelivery;
  screenProps: any;
}

export const renderToolTipOverlay = (title, message?) => (
  <OverlayTrigger
    trigger={"click"}
    key={title}
    placement={"bottom"}
    rootClose
    overlay={
      <Popover id={`popover-${title}`} className="badge badge-info">
        <Popover.Header as="h3">{`${title}`}</Popover.Header>

        <Popover.Body>{message}</Popover.Body>
      </Popover>
    }
  >
    <a>{<FaInfo size={10} />}</a>
  </OverlayTrigger>
);

const CartInfo = ({ order, screenProps }: CartInfoProps) => {
  const { setSelectedProduct: setSelectedProductForChat } =
    useContext(ChatContext);
  const dispatch = useDispatch();
  const toggleChat = useSelector(toggleChatSelector);
  const { fetchProduct } = useProduct();
  const { cancelOrder } = useContext(OrderContext);

  const chat = async (productId: string) => {
    const product = await fetchProduct(productId);
    setSelectedProductForChat(product);
    dispatch(toggleChatAction(!toggleChat));
    console.log({ product, toggleChat });
  };
  const [showOrderInfo, setShowOrderInfo] = useState("");
  const [infoToggle, setInfoToggle] = useState(false);
  const [isBusy, setIsBusy] = useState(false);
  const SwalAlert = withReactContent(Swal);
  const paidAmount = bankersRound(order?.cryptoPayment?.totalUsd?.v ?? 0) + bankersRound(order?.creditsPayment?.totalUsd?.v ?? 0) + bankersRound(order?.payPalPayment?.amount ?? 0) + bankersRound(order?.silaPayment?.amount ?? 0);


  const cancel = async () => {
    if (paidAmount > 0) {
      SwalAlert.fire({
        icon: 'warning',
        html: `<div><p><b>Oops, we couldn't remove the item, your item is already partically paid.</b></p><ul><li></li></ul></div>`,
        showCancelButton: false,
        confirmButtonText: 'Ok',
        confirmButtonColor: "#1478DD"
      });
    } else {
      const result = await SwalAlert.fire({
        icon: 'warning',
        html: `<div><p><b>Oops</b></p><ul><li><p>Are you sure, you want to cancel this order?</p></li></ul></div>`,
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        confirmButtonColor: "#1478DD"
      });
      if (result.isConfirmed) {
        setIsBusy(true);
        tagRemoveFromCart(order.productId, order.productName, order.productPrice, []);
        try {
          await cancelOrder(order.orderNumber);
          setIsBusy(false);
        } catch (err) {
          const errStr = err.toString().replace("FirebaseError: ", "");
          SwalAlert.fire({
            icon: 'warning',
            html: `<div><p><b>Oops, we couldn't remove the item</b></p><ul><li><p>${errStr}</p></li></ul></div>`,
            showCancelButton: false,
            confirmButtonText: 'Ok',
            confirmButtonColor: "#1478DD"
          });
          setIsBusy(false);
        }
      }
    }
  }

  return (
    <div>

      <div
        key={order?.orderNumber ?? "unknown-order"}
        className="mb-3 pb-2 border"
        style={{
          // boxShadow: "1px 2px 3px #c3c3c3",
        }}
      >
        {!!isBusy ?
          <div className="overflow-hidden"> <Lottie options={{ loop: true, autoplay: true, animationData: animeLoading }} heigth={250} width={250} /></div> :
          <>
            <OrderDetails>
              <div className="d-flex justify-content-around bg-light align-items-center">
                {/* <div className="col-12 col-sm-12 d-grid justify-content-between my-2 orderDetails" style={{ gridTemplateColumns: '1fr 1fr' }}>
            <div className="col-sm-6">
              <p className="col-sm-6">Added</p>
              <p className="col-sm-6">
                {moment(order.orderDate).format("MM/DD/yyyy")}
              </p>
            </div>
          </div> */}
              </div>
            </OrderDetails>

            <div className="d-sm-flex justify-content-between m-3">
              <div className="d-sm-flex align-items-start ">
                <div className="position-relative">
                  {/* <div className="form-check position-absolute" style={{ zIndex: 2 }}>
                <input className="form-check-input" type="checkbox" value="" id="selectedCart" checked readonly/>
              </div> */}
                  <div className="d-none d-sm-block ">
                    <Link href={`/p/${order.productId}${order.productSku !== order.productId ? `/${order.productSku}` : ""}`} passHref>
                      <Image
                        className="img-fluid"
                        src={order.productImage ?? "/images/missing.jpg"}
                        alt="product-image"
                        width={200}
                        height={200}
                        style={{ cursor: "pointer" }}
                      />
                    </Link>
                  </div>
                  <div className=" d-block d-sm-none">
                    <img
                      src={order.productImage ?? "/images/missing.jpg"}
                      alt="product-image "
                      className='img-fluid mb-4' />
                  </div>
                </div>
                <div className="mx-sm-3">
                  <div className="d-flex">
                    <p style={screenProps?.windowSize?.width >= 768 ? { width: 400 } : screenProps?.windowSize?.width >= 920 ? { width: 450 } : {}} className="fw-bold medium-text mb-0">{order.productName} </p>
                    {/* <p>{order}</p> */}
                    {/* {console.log('as', order)} */}
                  </div>

                  <div className="d-flex">
                    <p className="mb-0 medium-text" style={screenProps?.windowSize?.width >= 920 ? { width: 450 } : {}}>
                      {ReactHtmlParser(order?.productDescription?.substring(0, 200))}
                    </p>
                  </div>
                  <div className="col-md-5 col-lg-6 mb-4 mb-md-0 ">
                    {/* <p className="mb-0 fw-bold text-success">Delivery:</p> */}
                    <div className="mt-0 row">
                      <p style={{ whiteSpace: 'nowrap' }} className="mb-0 col-6 fw-bold text-success">{order?.shippingMethod == 'local_delivery' ? 'Local delivery' : order?.shippingMethod == 'local_pickup' ? 'Local pickup' : 'Shipping'}</p>
                      <p className="mb-0 col-6 fw-bold text-success">{order?.shippingPrice ? `$${twoDecimals(order?.shippingPrice)}` : "free"}</p>
                    </div>
                    {/* Tax wont be known until shipping zipcode is entered, so, don't show here. */}
                    {/* <div className="mt-0 row">
                <p className="mb-0 col-6 small-text text-black">Tax</p>
                <p className="mb-0 col-6 small-text ">${twoDecimals(order?.tax)}</p>
              </div> */}

                    {/* <div className="mt-0 row">
                <p className="mb-0 col-6 small-text text-black total">Total</p>
                <p className="mb-0 col-6 small-text" style={GetBold}>
                  ${twoDecimals(order?.subtotal)}
                </p>
              </div> */}
                  </div>
                  {console.log("cart", order)}
                  <div className="d-lg-flex align-items-center my-2" >
                    {/* <div className="border-right pe-lg-3 pb-2 pb-lg-0" style={screenProps?.windowSize?.width >= 920 ? { borderRight: "1px solid #d2d2d2" } : {}}>
                      <div className="d-flex align-items-center border px-1" style={{ width: 95, }}>
                        <span>Qty:</span>
                        <select className="form-select quantity-select " style={{ width: 60, border: 'none' }} disabled={true}>
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                          <option>9</option>
                          <option>10</option>
                        </select>
                      </div>
                    </div>
                    <div className="px-lg-3"
                    // style={screenProps?.windowSize?.width >= 920 ? { borderRight: "1px solid #d2d2d2" } : {}}
                    >
                      <p className="mb-0 cursor-pointer text-blue small-text" onClick={() => cancel()}>Remove</p>
                    </div>
                    {/* <div className="px-lg-3" style={screenProps?.windowSize?.width >= 920 ? { borderRight: "1px solid #d2d2d2" } : {}}>
                <p className="mb-0 text-blue small-text cursor-pointer">Save for later</p>
              </div> */}
                    {/* <div className="px-lg-3">
                      <p className="mb-0 cursor-pointer text-blue small-text"
                        onClick={async () => await chat(order.productId)}
                      >Chat with seller</p>
                    </div> */}
                  </div>
                  <div className="my-2">
                    {order?.customizationOptions?.length > 0 && !infoToggle && (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowOrderInfo(`show ${order.orderNumber}`);
                          setInfoToggle(true);
                        }}
                      >
                        More...
                      </a>
                    )}
                    {order?.customizationOptions?.length > 0 && infoToggle && (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowOrderInfo(`hide ${order.orderNumber}`);
                          setInfoToggle(false);
                        }}
                      >
                        Less
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <div className="my-2 col-sm-3">
                <div className="d-none d-md-block">
                  <h3 style={{ textAlignLast: 'end' }} >${twoDecimalsFixed(order?.productPrice)}</h3>
                </div>
                <div className="d-flex flex-column mx-auto">
                  {order.inprogressPayments?.length > 0 &&
                    <p> <span className="badge badge-pill badge-info blue-bg">${twoDecimalsFixed(order.inprogressPayments.reduce((acc, p) => acc + p.paymentAmount, 0))} Payment in progress</span></p>
                  }
                  {/* <button
              className="btn btn-light  my-2 reviewBtn"
              onClick={() => {
                router.push(`/checkout/${order?.orderHeaderId}`);
              }}
            >
              Checkout
            </button> */}
                  {/* <button
              className="btn btn-light  my-2 reviewBtn"
              onClick={async () => await chat(order.productId)}
            >
              Chat with Seller
            </button> */}
                  {/* <button
              className="btn btn-light  my-2 reviewBtn"
              onClick={async () => {
                tagRemoveFromCart(order.productId, order.productName, order.productPrice, [])
                cancelOrder(order.orderNumber)
              }
              }
            >
              Cancel
            </button> */}
                </div>
              </div>
            </div>
            {
              showOrderInfo === `show ${order.orderNumber}` && (
                <div className="hidding-info">
                  {(order?.customizationOptions?.length ?? 0) > 0 && (
                    <div className="border m-2 p-3">
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Customization Name</th>
                            <th>Option name</th>
                            <th>Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          {order?.customizationOptions?.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {item?.customizationName}
                                <span className="badge">
                                  {item?.description &&
                                    renderToolTipOverlay(
                                      `${item?.customizationName}`,
                                      `
                    ${item?.description?.length > 200
                                        ? item?.description.substring(0, 198) + "..."
                                        : item?.description
                                      }`
                                    )}
                                </span>
                              </td>
                              <td>{item?.optionName}</td>
                              <td>{item?.price}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </div>
              )
            }
          </>
        }
      </div >
    </div>
  );
};

export default CartInfo;
